import { render, staticRenderFns } from "./hot-sale.vue?vue&type=template&id=17a6a02b&scoped=true&"
import script from "./hot-sale.vue?vue&type=script&lang=js&"
export * from "./hot-sale.vue?vue&type=script&lang=js&"
import style0 from "./hot-sale.vue?vue&type=style&index=0&id=17a6a02b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6a02b",
  null
  
)

export default component.exports